import React, { useState, useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const InclusionExclusionField = (props) => {

    const { id,
        label,
        value = {},
        onChange,
        labelClass,
        placeholder = 'Search...',
        disabled = false, searchable = false } = props;
    const inclusion = value?.inclusion || value?.inclusions || [];
    const exclusion = value?.exclusion || value?.exclusions || [];
    const [includeList, setIncludeList] = useState(inclusion);
    const [excludeList, setExcludeList] = useState(exclusion);
    const [search, setSearch] = useState('');

    useEffect(() => {
        setIncludeList(inclusion);
        setExcludeList(exclusion);
    }, [value])

    const notifyChange = (inc, exc) => {
        onChange?.(id, {
            inclusion: inc,
            exclusion: exc,
        });
    };

    const moveItem = (item, fromInclude) => {
        if (disabled) return;

        let newInclude = [...includeList];
        let newExclude = [...excludeList];

        if (fromInclude) {
            newInclude = newInclude.filter((i) => i.key !== item.key);
            newExclude.push(item);
        } else {
            newExclude = newExclude.filter((i) => i.key !== item.key);
            newInclude.push(item);
        }

        setIncludeList(newInclude);
        setExcludeList(newExclude);
        notifyChange(newInclude, newExclude);
    };

    const filteredInclude = useMemo(
        () =>
            includeList.filter((i) =>
                i.name.toLowerCase().includes(search.toLowerCase())
            ),
        [includeList, search]
    );

    const filteredExclude = useMemo(
        () =>
            excludeList.filter((i) =>
                i.name.toLowerCase().includes(search.toLowerCase())
            ),
        [excludeList, search]
    );

    const excludeAll = () => {
        if (disabled) return;

        const toMove = filteredInclude;
        const remainingInclude = includeList.filter(
            i => !toMove.some(m => m.key === i.key)
        );

        const newExclude = [...excludeList, ...toMove];

        setIncludeList(remainingInclude);
        setExcludeList(newExclude);
        notifyChange(remainingInclude, newExclude);
    };

    const includeAll = () => {
        if (disabled) return;

        const toMove = filteredExclude;
        const remainingExclude = excludeList.filter(
            i => !toMove.some(m => m.key === i.key)
        );

        const newInclude = [...includeList, ...toMove];

        setIncludeList(newInclude);
        setExcludeList(remainingExclude);
        notifyChange(newInclude, remainingExclude);
    };


    return (
        <div className="form-group">
            {label && (
                <label htmlFor={id} className={labelClass}>
                    {label}
                </label>
            )}

            {/* Highlighted Box */}
            <div
                className="border rounded p-3"
                style={{
                    backgroundColor: disabled ? '#f8f9fa' : '#fff',
                    borderColor: '#ced4da',
                }}
            >
                {/* Search Box */}
                {searchable && <input
                    type="text"
                    className="form-control mb-3"
                    placeholder={placeholder}
                    value={search}
                    disabled={disabled}
                    onChange={(e) => setSearch(e.target.value)}
                />}

                <div className="row">
                    {/* Inclusions */}
                    <div className="col-md-6">
                        <h6 className="text-success">Inclusions</h6>
                        <button
                            className="btn btn-sm btn-outline-danger"
                            disabled={disabled || includeList.length === 0}
                            onClick={excludeAll}
                        >
                            Exclude All
                        </button>
                        <ul className="list-group">
                            {filteredInclude.length === 0 && (
                                <li className="list-group-item text-muted">No items</li>
                            )}
                            {filteredInclude.map((item) => (
                                <li
                                    key={item.key}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                    <span>{item.name}</span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger"
                                        disabled={disabled}
                                        onClick={() => moveItem(item, true)}
                                    >
                                        Exclude
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Exclusions */}
                    <div className="col-md-6">
                        <h6 className="text-danger">Exclusions</h6>
                        <button
                            className="btn btn-sm btn-outline-success"
                            disabled={disabled || excludeList.length === 0}
                            onClick={includeAll}
                        >
                            Include All
                        </button>
                        <ul className="list-group">
                            {filteredExclude.length === 0 && (
                                <li className="list-group-item text-muted">No items</li>
                            )}
                            {filteredExclude.map((item) => (
                                <li
                                    key={item.key}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                    <span>{item.name}</span>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-success"
                                        disabled={disabled}
                                        onClick={() => moveItem(item, false)}
                                    >
                                        Include
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InclusionExclusionField;
